import React from 'react'
import { Box } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import SampleCell from './@components/SampleCell'
import { skuGroupUsersModalFilters } from '../../@signals'

export default function usersColumn() {
    return {
        name: 'userSample', label: 'Users',
        options: {
            sort: false,
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: 'center', maxWidth: 260 } }),
            customBodyRowRenderLite: (value, row) => (
                <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
                    <SampleCell sample={value || []} total={row.numUsers} />
                    <IconSeeker
                        icon="users-gear"
                        tooltip="Manage users"
                        sx={{ fontSize: '0.875rem', cursor: 'pointer', color: 'text.secondary' }}
                        onClick={() => {
                            const userIDs = row.userIDs || []
                            skuGroupUsersModalFilters.value = {
                                skuGroupID: row.skuGroupID,
                                name: row.name,
                                customerID: row.customerID,
                                userIDs,
                                hadInitialUsers: userIDs.length > 0,
                            }
                        }}
                    />
                </Box>
            ),
        }
    }
}
